var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"30ce922a30d0bf791a22e7339a6e549b4e05c3a2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["daonative"]={id:"30ce922a30d0bf791a22e7339a6e549b4e05c3a2"};
      